import { __, __x, __nx, __N } from 'JIX/gettext.js';

export default {
    annonce: () =>
        __('Annonce'),
};
